import { default as Axios, default as axios } from 'axios';
import cookieCutter from 'cookie-cutter';
import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';

// import ShareBox from '../../hotissue/box/ShareBox';

export default function PGMBoxBTNArea(props) {
  const [swiperRef, setSwiperRef] = useState(null);
  const [maxPageCount, setMaxPageCount] = useState(0);
  const [naviCount, setNaviCount] = useState(1);

  // 현재 프로그램 구독 여부 (아이콘 토글용)
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  // 최초 구독 상태 세팅: 상위에서 내려주는 subscriptionMap을 신뢰
  useEffect(() => {
    const currentPgmId = props.data?.smr_pgm_id;
    if (!currentPgmId || !props.subscriptionFetched || !props.subscriptionMap) return;
    const currentResult = props.subscriptionMap?.[currentPgmId];
    setIsSubscribed(currentResult?.is_subscription === true);
  }, [props.data?.smr_pgm_id, props.subscriptionFetched, props.subscriptionMap]);

  const loginRedirect = () => {
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.href = `https://join.sbs.co.kr/login/login.do?returnUrl=${returnUrl}`;
  };

  const logClick = (name, extra = {}) => {
    try {
      window.__SBSLogModuleDataLayer.push({
        type: 'click',
        option: {
          clickName: name,
          clickType: 'NC',
          value1: props.data?.pgm_nm,
          value2: props.data?.pgm_id,
          value3: extra.value3 || '',
          value4: extra.value4 || '',
          value5: extra.value5 || ''
        }
      });
    } catch (_) {}
  };

  // 구독 요청
  const requestSubscribe = async (jwt, smrPgmId) => {
    const url = `https://apis.sbs.co.kr/play-api/1.0/subscription/program/${smrPgmId}`;
    await Axios.post(url, null, { headers: { 'jwt-token': jwt } });
  };

  // 구독 취소 요청
  const requestUnsubscribe = async (jwt, smrPgmId) => {
    const url = `https://apis.sbs.co.kr/play-api/1.0/subscription/program/${smrPgmId}`;
    await Axios.delete(url, { headers: { 'jwt-token': jwt } });
  };

  // 버튼 클릭 시: 즉시 액션 (레이어 없음)
  const handleToggleSubscribe = async (e) => {
    e?.preventDefault?.();

    logClick('프로그램테마 큐레이션 구독버튼');

    const jwt = cookieCutter.get('LOGIN_JWT');
    const smrPgmId = props.data?.smr_pgm_id;

    if (!jwt) {
      // 로그인 안 되어 있으면 곧바로 로그인 페이지로
      return loginRedirect();
    }
    if (!smrPgmId) {
      alert('구독 정보를 확인할 수 없습니다.');
      return;
    }

    try {
      if (isSubscribed) {
        // 즉시 구독 취소
        await requestUnsubscribe(jwt, smrPgmId);
        setIsSubscribed(false);
      } else {
        // 즉시 구독
        await requestSubscribe(jwt, smrPgmId);
        setIsSubscribed(true);
      }
    } catch (err) {
      console.error(err);
      alert('요청 처리 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
    }
  };

  const handleClick_custom = (e) => {
    logClick('프로그램테마 큐레이션 메뉴버튼', {
      value3: props.data?.button_nm,
      value4: props.data?.button_link
    });
  };

  const handleOpenPopup = (talk_id) => {
    logClick('프로그램테마 큐레이션 플레이톡버튼', { value4: props.data?.talk_id });
    window.open(
      `https://www.sbs.co.kr/playtalk/module.html?code=${talk_id}`,
      '타이틀명을 입력하시오',
      'top=0,left=0,width=485,height=928,status=no,menubar=no,toolbar=no,resizable=no'
    );
  };

  return (
    <>
      <div className="moduleBottomBtns">
        {/* 구독 버튼: 상태에 따라 current 클래스 토글 */}
        <a
          href="#none"
          className={isSubscribed ? 'btnType-subscribe current' : 'btnType-subscribe'}
          onClick={handleToggleSubscribe}
        >
          <span className="iconSvg_subscribe">
            <i className="hide">구독</i>
          </span>
        </a>

        {/* 플레이톡 버튼 */}
        <a
          href="#none"
          onClick={() => handleOpenPopup(props.data.talk_id)}
          className="btnType-playtalk"
          style={{ visibility: props.data?.talk_view_yn === 'Y' ? 'visible' : 'hidden' }}
        >
          <span className="iconSvg_playtalk"></span>
          <strong className="btnType-title">플레이톡</strong>
        </a>

        {/* 라이브/일반 버튼 */}
        {props.data?.onair_yn === 'Y' ? (
          <Link href="/ko/live">
            <a className="btnType-live">
              <span className="iconSvg_live"></span>
              <strong className="btnType-title">라이브</strong>
            </a>
          </Link>
        ) : (
          props.data?.button_view_yn === 'Y' && (
            <Link href={props.data.button_link}>
              <a
                onClick={handleClick_custom}
                target={props.data.link_new_yn === 'Y' ? '_blank' : ''}
                className="btnType-roundGray"
                style={{ visibility: props.data.button_view_yn === 'Y' ? 'visible' : 'hidden' }}
              >
                <strong className="btnType-title">
                  {props.data.button_nm} {props.data.programid}
                </strong>
              </a>
            </Link>
          )
        )}
      </div>
    </>
  );
}
